module.exports = __webpack_public_path__ + "static/media/capsules.fd79078b.svg";